module.exports = __webpack_public_path__ + "1_Goal_Progress_Modal-c1c41650590a36595e94e5022ebca3e8.png";